import type * as Api from 'Api'

export const pageKitErrorHandbook: Api.ErrorsHandbook<'default'> = {
  default: [],
}
